/**
 * Validates passwords against named PasswordValidationSchema. Each schema defines a minimum
 * length plus minimum counts of uppercase, numeric and special characters
 * (a count of 0 means that character class is not required).
 */

/// TODO  NOTE These MUST match the schemas defined in the PHP definition of the same name

export const PasswordValidationSchema = {
    basic: {
        minLength: 8,
        minUppercase: 1,
        minNumeric: 1,
        minSpecial: 0,
    },
    strong: {
        minLength: 12,
        minUppercase: 1,
        minNumeric: 1,
        minSpecial: 1,
    },
};

/**
 * Register or overwrite a named schema.
 */
function registerSchema(name, rules)
{
    PasswordValidationSchema[name] = rules;
}

function hasSchema(name)
{
    return Object.prototype.hasOwnProperty.call(PasswordValidationSchema, name);
}

const CHECKS = [
    ['minUppercase', /[A-Z]/g, 'uppercase'],
    ['minNumeric', /[0-9]/g, 'numeric'],
    ['minSpecial', /[^A-Za-z0-9]/g, 'special'],
];

/**
 * Validate a password against a named schema.
 * Returns { valid: boolean, errors: string[] }
 */
export function validatePassword(password, schemaName)
{
    if (!hasSchema(schemaName))
    {
        throw new Error(`Unknown password schema: ${schemaName}`);
    }

    const rules = PasswordValidationSchema[schemaName];
    const errors = [];

    const minLength = rules.minLength ?? 0;
    if (password.length < minLength)
    {
        errors.push(`Password must be at least ${minLength} characters long.`);
    }

    for (const [ruleKey, pattern, label] of CHECKS)
    {
        const minCount = rules[ruleKey] ?? 0;
        if (minCount <= 0)
        {
            continue;
        }

        const count = (password.match(pattern) || []).length;
        if (count < minCount)
        {
            errors.push(`Password must contain at least ${minCount} ${label} character(s).`);
        }
    }

    return {valid: errors.length === 0, errors};
}

// Example usage:
// validatePassword('Str0ng!Pass', 'strong'); // { valid: true, errors: [] }
//
// registerSchema('pin', { minLength: 4, minNumeric: 4 });
// validatePassword('1234', 'pin');

